module.exports = __webpack_public_path__ + "img/team.a535f963.svg";